import React from "react";
import Header from "../../../Navs/Header";
import NavbarVerticalV2 from "../../navbarVerticalV2/navbarVerticalV2";
import EtablissementSanteTable from "../../../Tables/Beneficiaire/EtablissementSante/EtablissementSanteTable";
import { useQuery } from "../../../../Http/http/query";

var EtablissementSante = () => {
  const query = useQuery("/prestatairebytype/Établissement santé/");
  return (
    <div className="dashboard-item-container">
      <div className="container-fluid body-background-dashboard">
        <Header />

        <div className="row">
          {/* Navbar Desktop  */}
          <div className="nav-container nav-assurance-color">
            <NavbarVerticalV2 />
          </div>

          <div className="offset-xl-1 offset-lg-1 col-xl-11 col-lg-11 col-md-12 content-position-after-header px-md-3 px-0 soinsy">
            <div className="page-body-container">
              <div className="page-content-container">
                <div className="page-first-row-container">
                  <div className="page-title-container">
                    <h1 className="page-title">Etablissements de santé</h1>
                  </div>
                </div>
                <div className="parent-table-container">
                  <EtablissementSanteTable {...query} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EtablissementSante;
